
function ensureTrailingSlash(url) {
  if (!url) return url;
  return url.endsWith("/") ? url : `${url}/`;
}

/** v4 base — env first, else derive from v3 / api origin (CRA inlines at build time). */
function getDsApis4BaseUrl() {
  const fromEnv = process.env.REACT_APP_BASE_URL_DS4;
  if (fromEnv) {
    return ensureTrailingSlash(fromEnv);
  }

  const fromV3 = process.env.REACT_APP_BASE_URL_DS3;
  if (fromV3) {
    const normalized = ensureTrailingSlash(fromV3);
    if (/\/v3\/$/i.test(normalized)) {
      return normalized.replace(/\/v3\/$/i, "/v4/");
    }
    return `${normalized.replace(/\/$/, "")}/v4/`;
  }

  const common = process.env.REACT_APP_BASE_URL;
  if (common) {
    try {
      const { origin } = new URL(common);
      return `${origin}/v4/`;
    } catch {
      // ignore invalid URL
    }
  }

  return "https://drug-sync-dev.gtc.local/v4/";
}

const SERVICE_BASE_URLS = {
  auth: process.env.REACT_APP_AUTH_SERVICE_URL,
  employee: process.env.REACT_APP_EMPLOYEE_SERVICE_URL,
  common: process.env.REACT_APP_BASE_URL,
  base: process.env.REACT_APP_BASE_URL,
  shift: process.env.REACT_APP_SHIFT_MANAGE_URL,
  payroll: process.env.REACT_APP_PAYROLL_SERVICE,
  notifications: process.env.REACT_APP_NOTIFICATIONS_SERVICE,
  notificationSocket: process.env.REACT_APP_NOTIFICATIONS_SOCKET,
  dsApis: process.env.REACT_APP_BASE_URL_DS,
  dsApis2: process.env.REACT_APP_BASE_URL_DS2,
  dsApis3: process.env.REACT_APP_BASE_URL_DS3,
  dsApis4: getDsApis4BaseUrl(),
  apiV1: process.env.REACT_APP_BASE_URL_V1,
  VITALS:process.env.VITALS
};

export default SERVICE_BASE_URLS;
